/**
 * Agent Builder sidebar folders: definitions + tool assignments are persisted via
 * agentbuilderd (OSM AgentWorkflow meta). Agent folder membership uses builder_folder_id on agents.
 */

export function normalizeSidebarFolderState(layout) {
  return {
    agentFolders: Array.isArray(layout?.agentFolders) ? layout.agentFolders : [],
    toolFolders: Array.isArray(layout?.toolFolders) ? layout.toolFolders : [],
    toolAssignments:
      layout?.toolAssignments && typeof layout.toolAssignments === 'object'
        ? { ...layout.toolAssignments }
        : {},
  };
}

export function defaultSidebarFolderState() {
  return normalizeSidebarFolderState(null);
}

export function generateSidebarFolderId() {
  return `fld_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 9)}`;
}

export function toolStableStorageKey(tool) {
  if (!tool) return '';
  const id = tool.originalData?.id ?? tool.id;
  if (id != null && id !== '') return String(id);
  return String(tool.name || tool.toolName || '');
}
